/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-09-14 18:41:22
 * @LastEditTime: 2023-11-01 14:53:19
 * @LastEditors: WangYuhan
 */
import Layout from '@/layout';

const invoiceRouter = {
  path: `/invoice`,
  component: Layout,
  redirect: `/invoice/channelInvoice`,
  alwaysShow: true, // will always show the root menu
  name: 'invoice',
  meta: {
    id: 5,
    title: '进项管理',
    icon: 'yzs_jinxiangguanli',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
  },
  children: [
    {
      path: 'netGoodsInvoice',
      component: () => import('@/views/invoice/netGoodsInvoice'),
      name: 'netGoodsInvoice',
      meta: {
        id: 51,
        title: '网货发票',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
    {
      path: 'oilInvoice',
      component: () => import('@/views/invoice/oilInvoice'),
      name: 'oilInvoice',
      meta: {
        id: 52,
        title: '油款发票',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
    {
      path: 'netGoodsServiceInvoice',
      component: () => import('@/views/invoice/netGoodsServiceInvoice'),
      name: 'netGoodsServiceInvoice',
      meta: {
        id: 53,
        title: '网货服务费发票',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
  ],
};
export default invoiceRouter;
